import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';

import { ApiEmpathySearch } from './api-empathy.models';


export interface ApiEmpathyServiceInterface {
  search(
    storeId: string,
    languageCode: string,
    catalogId: string,
    warehouse: string,
    query: string
  ): Observable<ApiEmpathySearch>;
}

@Injectable()
export class ApiEmpathyService implements ApiEmpathyServiceInterface {

  constructor(
    private readonly ecommerceConfigService: EcommerceConfigService,
    private readonly http: HttpClient
  ) { }

  public search(
    storeId: string,
    languageCode: string,
    catalogId: string,
    warehouse: string,
    query: string
  ): Observable<ApiEmpathySearch> {
    const url = this.requestUrl(storeId, languageCode, catalogId, warehouse, query);
    return this.http.get<ApiEmpathySearch>(url).pipe(
      catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
    );
  }

  private requestUrl(
    storeId: string,
    languageCode: string,
    catalogId: string,
    warehouse: string,
    query: string
  ): string {
    const config = this.ecommerceConfigService.getConfig();
    let url = '';
    if (config.providers?.empathySearchUrl) {
      url = `${config.providers.empathySearchUrl}`
        + `?lang=${languageCode}&catalogue=${catalogId}&store=${storeId}&warehouse=${warehouse}&query=${query}&rows=10`;
    }
    return url;
  }

}
